import React from 'react';

import "../stylesheets/ProjectSection.css"


// IndividualProject component
function IndividualProject(props) {
    const { completionDate, projectTitle, categorySkills, techSkills, blogDescription, blogRoute, blogImages } = props;

    return (
        <div className="individual-project">
            <div className="project-role">{completionDate}</div>
            <h1 className="project-name">{projectTitle}</h1>
            <div className="project-skills-container">
                <ul className="skill-category">
                    {categorySkills.map((skill) => (
                        <li key={skill} className="skill-category-box">{skill}</li>
                    ))}
                </ul>
                <ul className="skills-used">
                    {techSkills.map((skill) => (
                        <li key={skill} className="skill-box">{skill}</li>
                    ))}
                </ul>
            </div>

            <div className="project-button">
                <a tabIndex="0" href={blogRoute}>View Project</a>
                <a tabIndex="1" href={blogRoute}>View Project</a>
            </div>
            <p className="project-description" dangerouslySetInnerHTML={{ __html: blogDescription }}></p>

            <div className="project-image-container">
                {blogImages.map((image) => (
                    <a href={blogRoute} key={image} className="project-image-link">
                        <img src={image} alt="Project Image" className="project-image" />
                    </a>
                ))}
            </div>
        </div>
    );
}

export function Blog() {
    /*
   const projectData = {
       blogTitle: "",
       techSkills: "",
       projectLink: "",
       projectImages: [
           "",
       ],
       date: "2025-07-25"
   };
   */

    const SplunkSSHAuthAnalysisBlog = {
        completionDate: "6/30/2026",
        projectTitle: "SSH Brute Force Investigation with Splunk",
        categorySkills: ["Log Analysis", "Security"],
        techSkills: ["Splunk", "SPL", "VirusTotal", "AbuseIPDB", "Regex"],
    blogDescription: "Investigated <strong>~86,000 real-world SSH authentication events</strong> in Splunk, playing the role of an SOC analyst handed a suspicious auth.log with no prior context. Wrote all SPL queries from scratch across <strong>seven investigation phases</strong>. Profiling 2,607 attacking IPs, building <strong>time-windowed brute force detection logic</strong>, and synthesizing findings into actionable security recommendations.",
        blogRoute: "/blog/splunk-ssh-auth-analysis",
        blogImages: [
            "/images/Blog_Images/SplunkSSHAnalysis/attack_timeline_thumbnail.png",
        ]
    };

    const WarehouseNetworkRackBlog = {
        completionDate: "2/24/2026",
        projectTitle: "Warehouse Network Rack Build & Setup Guide",
        categorySkills: ["IT Administration", "Networking"],
        techSkills: ["Proxmox", "Docker", "Linux", "UniFi", "Frigate", "SNMP/NUT", "Backblaze B2", "EdgeRouter", "TP-Link"],
        blogDescription: "A step-by-step guide documenting the <strong>full network infrastructure</strong> I built and deployed solo for a workplace warehouse expansion, covering <strong>LAN design, server virtualization, wireless mesh networking, physical security systems, and automated cloud backup</strong>.",
        blogRoute: "/blog/warehouse-network-rack",
        blogImages: [
            "/images/Blog_Images/WarehouseNetworkRack/data_rack_thumbnail.jpg",
        ]
    };

    const WinActiveDirectoryBlog = {
        completionDate: "8/21/2025",
        projectTitle: "Windows Active Directory Lab Setup Guide",
        categorySkills: ["IT Administration", "Networking"],
        techSkills: ["Active Directory", "Group Policy Objects", "Network Config", "User Management" ,"VirtualBox", "Windows 10/Windows Server 2022"],
        blogDescription: "Created a guide from scratch on how to set up a <strong>Windows Active Directory lab</strong> using <strong>VirtualBox</strong>. The guide covers the installation of <strong>Windows Server 2022</strong>, configuration of <strong>Active Directory</strong>, and management of users and groups. It also includes troubleshooting tips and best practices for maintaining a secure and efficient lab environment.",
        blogRoute: "/blog/windows-active-directory-lab",
        blogImages: [
            "/images/Blog_Images/WinActiveDirectory/server_vm_thumbnail.png",
        ]
    };

    const DanaBotBlog = {
        completionDate: "7/25/2025",
        projectTitle: "DanaBot",
        categorySkills: ["Network Forensics", "Security"],
        techSkills: ["Wireshark", "VirusTotal", "ANY.RUN", "Network Miner", "Kali Linux"],
        blogDescription: "Identified the <strong>infection vector</strong>, analyzed the <strong>network traffic</strong>, and extracted <strong>indicators of compromise</strong> (IOCs) from a packet capture (PCAP) file of a system compromised by DanaBot malware.",
        blogRoute: "/blog/DanaBot",
        blogImages: [
            "/images/Blog_Images/DanaBot/1_identifying_suspicious_DNS_server.png",
        ]
    };

    return (
        <>
            <div className="about-page-container">
                <h1>Under Construction</h1>
                {/*<p>TODO: add "top skills used" section with counts of each tag being used.</p>*/}
            </div>

            <div className="projects-section" id='Projects'>
                <div className="projects-header">
                    <h1 style={{ display: 'flex', flexDirection: 'row' }}>
                        <div className="highlight">
                            <div>Posts</div>
                            <div></div>
                        </div>
                    </h1>
                </div>

                <div className="projects">
                    <IndividualProject {...SplunkSSHAuthAnalysisBlog} />
                    <IndividualProject {...WarehouseNetworkRackBlog} />
                    <IndividualProject {...WinActiveDirectoryBlog} />
                    <IndividualProject {...DanaBotBlog} />
                </div>
            </div>
        </>



    )


    const resumeLink = process.env.REACT_APP_RESUME_LINK;
}

export default Blog;